var f = Object.defineProperty, n = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var t = (o, e, r) => e in o ? f(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    s.call(e, r) && t(o, r, e[r]);
  if (i)
    for (var r of i(e))
      c.call(e, r) && t(o, r, e[r]);
  return o;
}, a = (o, e) => n(o, p(e));
import N, { forwardRef as d } from "react";
import l from "../lib/IconBase.mjs";
import w from "../defs/WifiNone.mjs";
const I = d((o, e) => /* @__PURE__ */ N.createElement(l, a(m({ ref: e }, o), { weights: w })));
I.displayName = "WifiNone";
export {
  I as WifiNone
};
